import { rangeCovered, type Range } from '$/epg/programs'
import { type LiveProgramCardInfo, type TvChannelWithLiveEpg } from '../index.h'

export const programsLoaded = (range: Range) => {
  const covered = rangeCovered(range)
  const toRange = (program: LiveProgramCardInfo) =>
    [program.startMs, program.stopMs] as Range

  return (channel: TvChannelWithLiveEpg) => {
    const loaded = channel.program.map(toRange)
    return covered(loaded)
  }
}
